import React, { FC } from 'react';
import Button from 'ui/Button/Button';
import content from 'components/modules/ContactUs/content';
import ContactCard from 'components/modules/ContactUs/ContactCard';
import ModalWindow from '../ModalWindow/ModalWindow';
import { IModalProps } from '../IModalProps';

const ContactUsModal: FC<IModalProps> = ({ open, onClose }) => (
  <ModalWindow
    title="Contact Us"
    open={open}
    onClose={onClose}
  >
    <>
      {content.map((props) => <ContactCard key={props.header} {...props} />)}
      <Button
        onClick={onClose}
        fullWidth
      >
        Close
      </Button>
    </>
  </ModalWindow>
);

export default ContactUsModal;
